const DollarIcon = function DollarIcon() {
  return (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>User Account</title>
      <g id="Dev-Ready-prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group">
          <circle id="Oval" fill="#424B50" cx="14" cy="14" r="14" />
          <g id="noun_Arrow_1920915" transform="translate(13.000000, 14.000000) rotate(-270.000000) translate(-13.000000, -14.000000) translate(7.000000, 10.000000)" fill="#FFFFFF" fillRule="nonzero">
            <polygon id="Path" points="-2.87208853e-14 2.13580247 2.17263158 -4.56150892e-14 6 3.74074074 9.82736842 -4.56150892e-14 12 2.13580247 6 8" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DollarIcon;
